import { Spinner } from '@/components/Spinner'
import styles from './LoadingOverlay.module.css'

interface LoadingOverlayProps {
  testId?: string
}

/**
 * The LoadingOverlay
 */
export function LoadingOverlay({ testId }: LoadingOverlayProps) {
  return (
    <div className={styles.root} data-test={testId}>
      <Spinner size={24} />
    </div>
  )
}
